/**
 * @module LastErrorStore
 * @description Store Zustand para gerenciar o último erro de requisições API.
 * Armazena mensagem e código HTTP do último erro ocorrido.
 *
 * @requires zustand
 */

import { create } from 'zustand';

/**
 * @typedef {Object} LastErrorStoreState
 * @property {string} message - Mensagem do último erro
 * @property {number} code - Código HTTP do último erro
 * @property {Function} setLastErrorMessage - Define a mensagem de erro
 * @property {Function} setLastErrorCode - Define o código HTTP do erro
 */

/**
 * Store Zustand para rastrear último erro de API.
 *
 * @constant
 * @type {import('zustand').UseBoundStore<LastErrorStoreState>}
 *
 * @example
 * // Acessar último erro em componente
 * import { useLastErrorStore } from '@welm/stores/lastErrorStore';
 *
 * function MostrarErro() {
 *   const message = useLastErrorStore(state => state.message);
 *   const code = useLastErrorStore(state => state.code);
 *
 *   return (
 *     <div>
 *       {message && <p>Erro {code}: {message}</p>}
 *     </div>
 *   );
 * }
 *
 * @remarks
 * - **Singleton**: Store compartilhada globalmente
 * - **Uso interno**: Usada principalmente por APILastError
 */
export const useLastErrorStore = create((set) => ({
  message: '',
  code: 200,
  setLastErrorMessage: (message) => set({ message }),
  setLastErrorCode: (code) => set({ code }),
}));
